import { Link } from "gatsby"
import React from "react"

const Header = () => (
  <header>
    <div className="md:h-24 py-4 md:py-0 flex md:flex-row flex-col items-center justify-between w-10/12 mx-auto">
      <div className="flex items-center">
        <h1 style={{ margin: 0, textAlign: "center" }} className="pr-4">
          <Link
            to="/"
            className="text-purple-900 text-xl font-medium tracking-wider"
          >
            Ayomikun
          </Link>
        </h1>
        <div style={{ width: "1px" }} className="bg-black h-6 mx-4"></div>
        <p className="text-sm opacity-50">Showcase</p>
      </div>

      <div className="mt-5 md:mt-0">
        <a
          href="/Sholademi-Ayomikun-Resume.pdf"
          target="_blank"
          className="opacity-75 hover:text-purple-900 underline"
        >
          Download Resume
        </a>
      </div>
    </div>
  </header>
)

export default Header
